<template>
  <div class="wrp fullHeight">
    <div style="display:none">{{triggerTackingLead}}{{tackingLeadFlag}}</div>
    <TackingLeadInfoList
      v-if="visableTackingLeadInfoList"
      :leadSn="leadSn"
      :socialLeadId="socialLeadId"
      :canFollowUp="true"
      :tutorChatToken="tutorChatToken"
    ></TackingLeadInfoList>
    <TackingLead
      v-if="visableTackingLead"
      :leadSn="leadSn"
      :socialLeadId="socialLeadId"
      :tutorChatToken="tutorChatToken"
    ></TackingLead>
    <div>
      <b-navbar type="light" fixed="bottom" class="navbarbg">
        <b-navbar-nav justified style="width:100%">
          <b-nav-item @click="showTackingLeadInfoList()" class="navbtn1">
            <img
              src="data:image/svg+xml;base64,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"
              alt="Kitten"
            />追蹤明細
          </b-nav-item>
          <b-nav-item @click="showTackingLead()" class="navbtn2">
            <img
              src="data:image/svg+xml;base64,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"
              alt="Kitten"
            />下 追 蹤
          </b-nav-item>
        </b-navbar-nav>
      </b-navbar>
    </div>
  </div>
</template>


<script>
import TackingLead from "../components/Main/TackingLead";
import TackingLeadInfoList from "../components/Main/TackingLeadInfoList";
import store_tackingLead from "@/vuex/store_tackingLead.js";
export default {
  components: {
    TackingLead,
    TackingLeadInfoList
  },
  data() {
    return {
      leadSn: "",
      socialLeadId: "",
      tutorChatToken: "",
      visableTackingLead: false,
      visableTackingLeadInfoList: true
    };
  },
  created() {
    document.title = "後續追蹤";
    if (this.$route.query.ls != null && this.$route.query.ls != undefined) {
      this.leadSn = this.$route.query.ls;
    }
    if (this.$route.query.sli != null && this.$route.query.sli != undefined) {
      this.socialLeadId = this.$route.query.sli;
    }
    this.tutorChatToken = this.$route.query.tct;
    //手機板因為進到後續追蹤頁的都會是自己的主聯客戶，所以沒有操作者跟主聯不同的問題。
    store_tackingLead.dispatch("setOperatorIsMainContact", true);
  },
  methods: {
    showTackingLead: function() {
      this.visableTackingLead = true;
      this.visableTackingLeadInfoList = false;
    },
    showTackingLeadInfoList: function() {
      this.visableTackingLead = false;
      this.visableTackingLeadInfoList = true;
    }
  },
  computed: {
    triggerTackingLead(){
      var careSn = store_tackingLead.state.careSn;
      if(careSn != ""){
        this.showTackingLead();
      }
    },
    tackingLeadFlag(){
      this.showTackingLeadInfoList();
      return store_tackingLead.state.flag;
    }
  }
};
</script>

<style scoped>
.navbarbg {
  background: transparent;
  padding: 17px;
}

.navbar-light .navbar-nav .nav-link {
  border-radius: 4px;
  background: #b20404;
  color: #fff;
  padding: 0.6rem 1rem;
}

.navbtn1 {
  margin-right: 7px;
}

.navbtn2 {
  margin-left: 7px;
}

.nav-link img {
  width: 23px;
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/MobileTackingLeadView.vue